import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Root index route - redirects to PC home
 * This replaces the React Router redirect: <Redirect from="/" to="/edge/pc" />
 *
 * Authentication is handled by the parent _protected layout route.
 */
export const Route = createFileRoute('/_protected/')({
  beforeLoad: async () => {
    // Auth is handled by parent _protected, just redirect to PC home
    throw redirect({
      to: '/pc',
    });
  },
});
